import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEdit,
  faUser,
  faEnvelope,
  faTrashAlt,
} from "@fortawesome/free-regular-svg-icons";

library.add(faEdit, faUser, faEnvelope, faTrashAlt);
